import { render, staticRenderFns } from "./PriorityTicketModal.vue?vue&type=template&id=4929a9bd&scoped=true"
import script from "./PriorityTicketModal.vue?vue&type=script&lang=js"
export * from "./PriorityTicketModal.vue?vue&type=script&lang=js"
import style0 from "./PriorityTicketModal.vue?vue&type=style&index=0&id=4929a9bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4929a9bd",
  null
  
)

export default component.exports